import { DashboardStatisticsPeriodListItem } from '@/models/statistics/dashboard-statistics-period-list.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { defineStore } from 'pinia';

interface DashboardStatisticsPeriodListState {
  dashboardStatisticsPeriodList: DashboardStatisticsPeriodListItem[];
  isDashboardStatisticsPeriodListLoading: boolean;
}

export const useDashboardStatisticsPeriodListStore = defineStore('DashboardStatisticsPeriodListStore', {
  state: (): DashboardStatisticsPeriodListState => ({
    isDashboardStatisticsPeriodListLoading: false,
    dashboardStatisticsPeriodList: [],
  }),
  actions: {
    setDashboardStatisticsPeriodListLoading(isLoading: boolean): void {
      this.isDashboardStatisticsPeriodListLoading = isLoading;
    },
    getDashboardStatisticsPeriodList(whitelabelSlug: string): Promise<DashboardStatisticsPeriodListItem[]> {
      if (this.dashboardStatisticsPeriodList.length) {
        return Promise.resolve(this.dashboardStatisticsPeriodList);
      }

      this.setDashboardStatisticsPeriodListLoading(true);

      return api.statistics.getDashboardStatisticsPeriodListRequest.perform(whitelabelSlug)
        .then((data: DashboardStatisticsPeriodListItem[]) => {
          this.dashboardStatisticsPeriodList = data;

          return data;
        })
        .catch((error) => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setDashboardStatisticsPeriodListLoading(false);
        });
    },
  },
});
